module.exports = __webpack_public_path__ + "static/media/documentTile.4fe2419d.jpg";